.gridItem {
  &[data-dragging='true'] {
    opacity: 0.4;
  }

  // Drop target — primary subtle tint plus an accent line whose direction
  // follows which half of the card the cursor is over. Top half = top
  // accent (insert above), bottom half = bottom accent (insert below).
  &[data-drop-target='true'] {
    background: var(--bs-primary-bg-subtle);
  }

  // `--bs-link-color` re-tints under `[data-bs-theme=dark]`; `--bs-primary` is a fill
  // token and stays fixed, leaving the accent at 2.27:1 against the dark card.
  &[data-drop-target='true'][data-drop-side='before'] {
    box-shadow: inset 0 3px 0 var(--bs-link-color);
  }

  &[data-drop-target='true'][data-drop-side='after'] {
    box-shadow: inset 0 -3px 0 var(--bs-link-color);
  }
}
